import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useEffect, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import { Size } from '../../Constants/System';
import SimpleInput from './SimpleInput';
export default forwardRef(function PinInput(props, ref) {
    const { className, length, onChange, mask, disabled, size } = props;
    const elRefs = useRef([]);
    const valueParts = useRef(Array.from({ length }).fill(''));
    const handleOnChange = (value, index) => {
        if (value.length === 0) {
            valueParts.current[index] = '';
            if (index > 0) {
                elRefs.current[index - 1].focus();
            }
            else {
                elRefs.current[index].focus();
            }
        }
        else if (value.length === 1) {
            valueParts.current[index] = value;
            if (index === length - 1) {
                onChange?.(valueParts.current.join(''));
                return;
            }
            else if (index < length - 1) {
                elRefs.current[index + 1].focus();
            }
        }
        else {
            const characters = value.substring(index, length).split('');
            characters.forEach((character, i) => {
                valueParts.current[index + i] = character;
                elRefs.current[index + i].value = character;
            });
            if (index + characters.length === length) {
                elRefs.current[length - 1].focus();
            }
            else {
                elRefs.current[index + characters.length - 1].focus();
            }
        }
        onChange?.(valueParts.current.join(''));
    };
    const handleOnKeyDown = (event, index) => {
        const currentVal = event.target.value;
        if (currentVal.length === 1 && event.key !== 'Backspace' && index < length - 1) {
            elRefs.current[index + 1].focus();
        }
        else if (currentVal.length === 0 && event.key === 'Backspace' && index > 0) {
            elRefs.current[index - 1].focus();
        }
    };
    const handleOnPaste = (event, index) => {
        event.preventDefault();
        const pastedText = event.clipboardData.getData('text');
        const characters = pastedText.substring(0, length - index);
        for (let i = 0; i < characters.length; i++) {
            valueParts.current[index + i] = characters[i];
            elRefs.current[index + i].value = characters[i];
        }
        if (index + characters.length === length) {
            elRefs.current[length - 1].focus();
        }
        else {
            elRefs.current[index + characters.length].focus();
        }
        onChange?.(valueParts.current.join(''));
    };
    const focusFirstInput = () => {
        const el = elRefs.current[0];
        if (el) {
            el.focus();
        }
    };
    const reset = () => {
        valueParts.current = Array.from({ length }).fill('');
        elRefs.current.forEach((el) => {
            el.value = '';
        });
        focusFirstInput();
    };
    useEffect(focusFirstInput, []);
    useImperativeHandle(ref, () => ({
        inputRefs: elRefs,
        focusFirstInput,
        reset,
    }));
    return (_jsx(StyledPinInput, { className: `PinInput ${(size ?? Size.medium).toLowerCase()}${className ?? ''}`, children: Array.from({ length }).map((_, index) => {
            const key = `PinInput-${index}`;
            return (_jsx(SimpleInput, { maxLength: 1, ref: (ref) => {
                    if (ref) {
                        elRefs.current[index] = ref;
                    }
                }, type: mask ? 'password' : 'text', onKeyDown: (event) => {
                    handleOnKeyDown(event, index);
                }, onChange: (event) => {
                    handleOnChange(event.target.value, index);
                }, onPaste: (event) => {
                    handleOnPaste(event, index);
                }, disabled: disabled }, key));
        }) }));
});
const StyledPinInput = styled.div `
	display: flex;
	flex-wrap: nowrap;

	input {
		text-align: center;
		padding: 0;
	}

	&.large input {
		width: 2em;
		height: 2em;
		font-size: 1.5em;
		margin: 0 0.5em;
	}

	&.medium input {
		width: 1.8em;
		height: 2em;
		font-size: 1.25em;
		line-height: 1.5em;
		margin: 0 0.3em;
	}

	&.small input {
		width: 1.5em;
		height: 1.5em;
		font-size: 1em;
		line-height: 1.5em;
		margin: 0 0.2em;
	}
`;
//# sourceMappingURL=PinInput.js.map